import {
	OnboardingUserAppContextType,
	useOnboardingUserContext,
} from '../../../store'
import EditProfileComponent from '../../../components/profile-component/EditProfileComponent'
import React from 'react'
import { Grid } from '@adsk/alloy-react-box'
import Theme from '@adsk/alloy-react-theme'
import EditProfileLoaderComponent from '../../../components/profile-component/EditProfileLoaderComponent'
import { useTranslation } from '../../../../i18n'
import { isBCNonGhostUser } from '../../../utils/helpers'

const BodyComponent = (): JSX.Element => {
	const {
		state: { showLoader, userInfo },
	} = useOnboardingUserContext() as OnboardingUserAppContextType

	const { t } = useTranslation()
	const { spacing, typography } = Theme
	const isBcNonGhostUser = isBCNonGhostUser(userInfo)
	return (
		<>
			{showLoader && <EditProfileLoaderComponent />}
			{!showLoader && (
				<>
					<Grid gridGap={2}>
						<span
							data-testid={'profile-message'}
							style={{
								...(isBcNonGhostUser
									? typography.heading5
									: typography.heading4),
								marginBottom: spacing.small,
							}}
						>
							{isBcNonGhostUser
								? t('LINKED_BC_ACCOUNT_MESSAGE')
								: t('PROFILE_BODY')}
						</span>
					</Grid>

					<EditProfileComponent />
				</>
			)}
		</>
	)
}

export default BodyComponent
